import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import './StatGraph.scss';

const StatGraph = ({
  loss, gain, lossLabel, gainLabel,
}) => (
  <section className="stat-graph">
    <div className="stat-graph__stat">
      <span className="stat-graph__stat__worst">{`-${loss}%`}</span>
      <div className="stat-graph__graph">
        <div className="stat-graph__graph__worst" style={{ width: `${loss}%` }} />
        <div className="stat-graph__graph__gain" style={{ width: `${gain}%` }} />
      </div>
      <span className="stat-graph__stat__gain">{`${gain}%`}</span>
    </div>
    <div className="stat-graph__desc">
      <FormattedMessage id={lossLabel} />
      <FormattedMessage id={gainLabel} />
    </div>
  </section>
);

StatGraph.propTypes = {
  /** value in loss */
  loss: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** loss label */
  lossLabel: PropTypes.string,
  /** value in gain */
  gain: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Gain Label */
  gainLabel: PropTypes.string,
};

StatGraph.defaultProps = {
  loss: null,
  lossLabel: 'risk.worstYear',
  gain: null,
  gainLabel: 'risk.bestYear',
};

export default StatGraph;
